import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 2),
    },
    attachmentsWrapper: {
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'flex-end',
      gap: theme.spacing(0.5),
    },
    variables: {},
    attachments: {},
    buttonAdd: {
      color: COLORS.gray.black,
      padding: theme.spacing(0.75),
      border: theme.shape.borderGray70,
      backgroundColor: COLORS.gray.white,
      minWidth: 'unset',
      fontWeight: theme.typography.fontWeightRegular,
    },
    actions: {},
    instructions: {},
  }),
  { name: 'Footer' }
);
